import React from "react";
import { X, FileText } from "lucide-react";
import ChapterBlocks from "@/components/ChapterBlocks";

export default function AppendixReader({ appendix, onClose }) {
  if (!appendix) return null;

  return (
    <div className="fixed inset-0 z-50 bg-[var(--bloom-ink)]/70 backdrop-blur-sm overflow-y-auto" data-testid="appendix-reader-modal">
      <div className="min-h-screen flex items-start md:items-center justify-center p-4 md:p-12">
        <div className="bg-[var(--bloom-bg)] max-w-3xl w-full relative bloom-rise shadow-2xl">
          {/* Top bar */}
          <div className="sticky top-0 z-10 flex items-center justify-between px-8 md:px-14 py-5 border-b border-[var(--bloom-border)] bg-[var(--bloom-bg)]">
            <div className="flex items-center gap-3 text-xs text-[var(--bloom-ink-muted)] tracking-[0.15em] uppercase">
              <FileText size={12} />
              <span>Appendix {appendix.letter}</span>
            </div>
            <button onClick={onClose} className="bloom-btn bloom-btn-ghost" data-testid="appendix-close-btn">
              <X size={16} /> Close
            </button>
          </div>

          <article className="px-8 md:px-16 py-12 md:py-16">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[var(--bloom-ink-muted)] mb-6">
              ✦ Bloom Club Prospectus · Appendix ✦
            </div>
            <div className="font-serif text-7xl text-[var(--bloom-brand)] leading-none mb-3">{appendix.letter}</div>
            <h1 className="font-serif text-4xl md:text-5xl leading-[1.05] mb-3" data-testid="appendix-reader-title">{appendix.title}</h1>
            <p className="font-serif italic text-xl text-[var(--bloom-ink-soft)] mb-10">{appendix.subtitle}</p>

            <div className="bloom-divider mb-10">Reference Material</div>

            <ChapterBlocks blocks={appendix.blocks} />

            <div className="bloom-divider my-12">✦ end of appendix ✦</div>

            <div className="flex justify-center">
              <button onClick={onClose} className="bloom-btn bloom-btn-primary" data-testid="appendix-done-btn">
                Return to Portal
              </button>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
}
